<style src="./styles/global.scss" lang="scss"></style>
<style lang="scss" scoped>
@include component(layout) {
	@include part(offline) {
		position: fixed;
		top: 0;
		left: 0;
		text-align: center;
		padding: 20px;
		background: #f44336;
		color: white;
		font-size: 18px;
		font-size: 500;
		width: 100%;
		z-index: 40000;
	}
}
.layout {
	min-width: 1060px;
}
</style>

<template>
<div id="app" class="layout" :class="providerCode">
        <offline>
            <div class="layout__offline" slot="offline">
                No internet connection detected
            </div>
        </offline>
        <div v-if="$route.meta.layout === 'auth'">
            <router-view/>
        </div>
        <div v-else>
            <router-view/>
        </div>
    </div>
</template>
<script>
import AppHeader from "./includes/Header";
import OrgAppHeader from "./includes/OrgHeader";
import offline from "v-offline";
import _ from "lodash";

export default {
	name: "App",
	components: {
		AppHeader,
		OrgAppHeader,
		offline
	},
	mounted() {
		/**
		 * Detect if the mouse or keyboard are inactive,
		 * If they are we fire the skip polling event to prevent extra requests when the webpage has not been closed.
		 * Once an event is triggered, send the false flag
		 */
		var timeoutInMiliseconds = 60 * 1000;
		var timeoutId;

		const startTimer = () => {
			timeoutId = window.setTimeout(doInactive, timeoutInMiliseconds);
		};

		const doInactive = () => {
			this.$bus.emit("window-inactive", true);
		};

		const resetTimer = () => {
			window.clearTimeout(timeoutId);
			this.$bus.emit("window-inactive", false);
			startTimer();
		};

		const setupTimers = () => {
			document.addEventListener(
				"mousemove",
				_.debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			document.addEventListener(
				"mousedown",
				_.debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			document.addEventListener(
				"keypress",
				_.debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			document.addEventListener(
				"touchmove",
				_.debounce(resetTimer, 5000, {
					leading: true,
					trailing: false
				}),
				false
			);
			startTimer();
		};

		setupTimers();
	}
};
</script>